import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {Card, FormGroup, Input} from "reactstrap";
import TaskGroupTraining from "../tasks-training/TaskGroupTraining";
import Modal from "../../../shared/ui/Modal";
import TaskGroupTrainingDetails from "../tasks-training/TaskGroupTrainingDetails";
import taskTrainingActionCreators from "../../store/task-training/action-creators";
import oitsActionCreators from "../../store/oits/action-creators/index";
import tagsSelectors from "../../store/tags/selectors";
import tagsActionCreators from "../../store/tags/action-creators";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import {createSubgroups} from "../../../shared/services/utils/tasks";
import './DashboardTaskTraining.scss'
const getTaskGroupTag = (taskGroup) =>
  taskGroup.tags.find(tag => tag.for === 'task-group' && tag.sequence !== null);

class DashboardTaskTraining extends Component {

  constructor(props) {
    super(props);

    this.state = {
      taskTraining: null,
      selectedTaskGroupGuid: null,
      selectedOit: '',
      isAddingResponse: false,
      isLoading: false,
      editingResponse: null,
      trainingNotStarted: false,
      filters: {
        selectedTagGuid: '',
        search: ''
      },
      filterByStatus: 'opened',
    };

  }

  componentDidMount() {

    this.setSelectedOit(this.props.oitGuid);
  }


  componentDidUpdate(prevProps, prevState, snapshot) {

    if(prevProps.oitGuid !== this.props.oitGuid) {
      this.setSelectedOit(this.props.oitGuid);
    }
  }


  setSelectedOit(oitGuid) {
    this.setState({
      selectedOit: oitGuid,
      isLoading: true,
      trainingNotStarted: false
    });

    this.props.fetchTaskTraining(oitGuid)
      .then(res => {
        this.setState({
          isLoading: false
        });
      }).catch(() => {
      this.setState({
        trainingNotStarted: true,
        isLoading: false
      })
    });
  }

  setSelectedTag(tagGuid) {
    this.setState({
      filters: {
        ...this.state.filters,
        selectedTagGuid: tagGuid
      }
    })
  }

  setSearch(search) {
    this.setState({
      filters: {
        ...this.state.filters,
        search
      }
    })
  }

  showTaskGroupDetails(taskGroup) {
    this.setState({
      selectedTaskGroupGuid: taskGroup.taskGroupGuid
    })
  }

  closeTaskGroupDetails() {
    this.setState({
      selectedTaskGroupGuid: null
    })
  }

  editResponse(data) {
    this.setState({
      editingResponse: data
    })
  }

  cancelEditResponse(data) {
    this.setState({
      editingResponse: null
    })
  }

  get canAddOrEdit() {
    if (this.selectedTaskGroup.flow) {
      if (this.selectedTaskGroup.flow.submitter == 'fto') {
        const roles = ['fto', 'ftoc', 'sup'];
        return this.props.userContext.hasScope(roles);
      }
      return this.props.userContext.hasScope(this.selectedTaskGroup.flow.submitter);
    }

    // this is needed for task groups where flow == null
    return !this.props.userContext.hasScope('oit');
  }

  taskCardClick(task) {
    if (task.toggleAccordion) {
      task.toggleAccordion = !task.toggleAccordion;
    } else {
      task.toggleAccordion = true;
    }

    // the purpose is to force changing the state so the child compenets are re-rendered. Is there a better way to accomplish the same?
    const isAddingResponse = this.state.isAddingResponse;
    this.setState({
      isAddingResponse: isAddingResponse
    });
  }

  taskCardsExpand(tasks) {
    tasks.forEach(function (task) {
      task.toggleAccordion = true;
    });

    const isAddingResponse = this.state.isAddingResponse;
    this.setState({
      isAddingResponse: isAddingResponse
    });
  }

  saveResponse(data) {
    this.setState({
      isAddingResponse: true
    });

    if(this.state.editingResponse) {
      return this.props.updateResponse(this.state.editingResponse, data)
        .then(() => this.props.submitResponse(this.state.editingResponse))
        .then(() => {
          this.setState({
            isAddingResponse: false,
            editingResponse: null
          })
        })
    } else {
      return this.props.saveResponses({
        ...data,
        oitGuid: this.state.selectedOit
      })
        .then((responses => Promise.all(responses.map(response => this.props.submitResponse(response)))))
        .then(() => {
          this.setState({
            isAddingResponse: false
          })
        })
    }

  }

  submitResponse(data) {
    this.setState({
      isAddingResponse: true
    });

    this.props.submitResponse(data).then(() => {
      this.setState({
        isAddingResponse: false
      })
    })
  }


  rejectResponse(data) {
    this.setState({
      isAddingResponse: true
    });

    this.props.rejectResponse(data).then(() => {
      this.setState({
        isAddingResponse: false
      })
    })
  }

  get selectedTaskGroup() {
    return this.currentTaskTraining &&
      this.currentTaskTraining
        .reduce((acc, tg) => {
          return [
            ...acc,
            tg,
            ...(tg.subGroups || [])
          ]
        }, [])
        .find(tg => tg.taskGroupGuid === this.state.selectedTaskGroupGuid)
  }

  get currentTaskTraining() {
    return this.state.selectedOit
      && this.props.taskTrainingMap
      && this.props.taskTrainingMap[this.state.selectedOit]
      && createSubgroups(this.props.taskTrainingMap[this.state.selectedOit]);
  }

  get filteredTaskTraining() {

    let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
    return this.currentTaskTraining
      && this.currentTaskTraining
        .filter(tg => this.selectedTag
          ? tg.tags.find(t => t.tagGuid === this.selectedTag.guid)
          : true)
        .filter(tg => this.state.filters.search
          ? tg.name.toLowerCase().includes(this.state.filters.search.trim().toLowerCase())
          : true)
        .sort((a, b) => {
          return collator.compare(a.name, b.name)
        });
  }

  get selectedTag() {
    return this.props.taskGroupTags && this.props.taskGroupTags.find(t => t.guid == this.state.filters.selectedTagGuid)
  }

  get filteredByStatus() {
    if (this.props.oits) {
      return this.props.oits.filter(this.filterOit.bind(this));
    }

    return [];
  }

  get oitsInProgress() {
    return this.filteredByStatus;
  }

  get canAdd() {
    return this.props.userContext.hasScope(['fto', 'ftoc', 'sup'])
  }

  isTrainingCompleted(trainingTracker, trainingPhases) {
    return (trainingTracker
        && trainingTracker.status === 'closed')
      || (trainingPhases.length > 0 && trainingPhases.filter((phase) => phase.status === 'completed').length === trainingPhases.length)
  }

  filterOit(oit) {
    if (this.state.filterByStatus === 'new') {
      return !oit.trainingTracker || !oit.trainingTracker.status;
    } else if (this.state.filterByStatus === 'completed') {
      return this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
    } else if (this.state.filterByStatus === 'opened') {
      return (
        !oit.trainingTracker || oit.trainingTracker.status === 'opened' || !oit.trainingTracker.status
      ) && !this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
    }
    return true;
  }

  taskCardsCollapse(tasks) {
    tasks.forEach(function (task) {
      task.toggleAccordion = false;
    });

    const isAddingResponse = this.state.isAddingResponse;
    this.setState({
      isAddingResponse: isAddingResponse
    });
  }

  get canAck() {
    return this.props.userContext.hasScope('oit')
  }

  selectedOitObject(selectedOit) {
    return this.oitsInProgress
      && this.oitsInProgress.find(tp => tp.guid === selectedOit)
  }

  setFilterBy(filterByStatus) {
    this.setState({selectedOit: ''});
    this.setState({filterByStatus});
  }

  render() {
    return (
      <div className="dashboard-task-training">
        <div className="task-training">
          <Card className="task-groups-training">
            {this.filteredTaskTraining ? (
              <div className="form form-inline task-training-filters">
                <div className="form-group">
                  <Input
                    name="type"
                    onChange={event =>
                      this.setSelectedTag(event.target.value)
                    }
                    type="select"
                    value={this.state.filters.selectedTagGuid}
                  >
                    <option defaultValue={''}>{this.selectedTag ? 'Show all': 'Select tag'}</option>
                    {this.props.taskGroupTags && this.props.taskGroupTags.map(tag => (
                      <option key={tag.guid} value={tag.guid}>{tag.name}</option>
                    ))}
                  </Input>
                </div>
                <FormGroup>
                  <Input
                    onChange={event => this.setSearch(event.target.value)}
                    type="text"
                    value={this.state.filters.search}
                    placeholder="Search"
                  />
                </FormGroup>
              </div>
            ) : this.state.selectedOit && <h3 className="text-center mt-3">Training not Started</h3>}
            {this.filteredTaskTraining && this.filteredTaskTraining.map(taskGroup => (
              <TaskGroupTraining
                onOpenTasks={(tg) => this.showTaskGroupDetails(tg)}
                taskGroup={taskGroup}
                key={taskGroup.taskGroupGuid} />
            ))}
          </Card>
        </div>
        <Modal
          fullscreen={true}
          isOpen={!!this.selectedTaskGroup}
          title={this.selectedTaskGroup && this.selectedTaskGroup.name}
          onClose={() => this.closeTaskGroupDetails()}>
          {this.selectedTaskGroup && (
            <TaskGroupTrainingDetails
              onSaveResponse={(data) => this.saveResponse(data)}
              onSubmitResponse={(data) => this.submitResponse(data)}
              onRejectResponse={(data) => this.rejectResponse(data)}
              onEditResponse={(data) => this.editResponse(data)}
              onCancelEditResponse={() => this.cancelEditResponse()}
              editingResponse={this.state.editingResponse}
              isLoading={this.state.isAddingResponse}
              canAddOrEdit={this.canAddOrEdit}
              oitGuid={this.state.selectedOit}
              canAck={this.canAck}
              onTaskCardClick={(task) => this.taskCardClick(task)}
              onExpandAllClick={(tasks) => this.taskCardsExpand(tasks)}
              onCollapsellClick={(tasks) => this.taskCardsCollapse(tasks)}
              onReferenceMaterialUpdate={(guid, index, completed) => this.props.updateReferenceMaterialResponses({
                guid: guid,
                oitGuid: this.state.selectedOit,
                responses: {
                  [index]: completed
                }
              })
              }
              taskGroup={this.selectedTaskGroup}/>
          )}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    taskTrainingMap: state.taskTraining.taskTrainingMap,
    oits: state.oits.list,
    userContext: state.common.userContext,
    taskGroupTags: tagsSelectors.taskGroupTags(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTaskTraining: (oitGuid) => {
      return dispatch(taskTrainingActionCreators.fetchTaskTraining(oitGuid))
    },
    saveResponses: ({oitGuid, taskGuid, actions, actionAt, comment, substandard}) => {
      return dispatch(taskTrainingActionCreators.addResponses(oitGuid, taskGuid, actions, actionAt, comment, substandard))
    },
    submitResponse: ({guid, oit, task, action}) => {
      return dispatch(taskTrainingActionCreators.submitResponse(guid, oit.guid, task.guid, action))
    },
    rejectResponse: (data) => {
      return dispatch(taskTrainingActionCreators.rejectResponse(data))
    },
    updateResponse: ({guid, oit, task, action, authorComment}, {actions, actionAt, comment, substandard}) => {
      return dispatch(taskTrainingActionCreators.updateResponse(guid, oit.guid, task.guid, actions[0] || action, actionAt, comment || authorComment, substandard))
    },
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope));
    },
    fetchTags: () => {
      return dispatch(tagsActionCreators.fetchTags())
    },
    updateReferenceMaterialResponses: (data) => {
      return dispatch(taskTrainingActionCreators
        .updateReferenceMaterialResponses(data))
    }
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardTaskTraining));
